// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1umYG","row":"Node_row__2Vjqm","label":"Node_label__16MjA","footer":"Node_footer__3y8Bv"};